import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getToken } from '../api/auth/auth';

export default function ProtectedRoute(): React.ReactElement {
  const [hasToken, setHasToken] = useState<boolean>(!!getToken());
  const navigate = useNavigate();
  const location = useLocation();

  // Re-check na każdą zmianę trasy
  useEffect(() => {
    setHasToken(!!getToken());
  }, [location.pathname]);

  // Re-check przy powrocie do karty (manualne usunięcie w DevTools zostanie wykryte)
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        const ok = !!getToken();
        setHasToken(ok);
        if (!ok) navigate('/admin/login', { replace: true });
      }
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [navigate]);

  if (!hasToken) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
